import { useQuery } from "hooks/useQuery";
import {
  getPublicStrategyDetails,
  getStrategyDetails,
} from "features/Strategy/service";

export const useStrategyDetails = (id, isPublicStrategy = false) => {
  const { isLoading, data, refetch } = useQuery({
    key: "strategyDetails",
    queryKey: ["strategyDetails", id, isPublicStrategy],
    queryFn: async () => {
      if (isPublicStrategy) {
        const response = await getPublicStrategyDetails(id);
        return response;
      }
      const response = await getStrategyDetails(id);
      return response;
    },
    enabled: !!id,
  });

  return { isLoading, data, refetch };
};
